
//#region import libraries
import { getToken } from "./user-service";
import axios from "axios";
//#endregion

//#region seasonal variance 
//get seasonsal variance by iata
export const getSeasonalVariances = async (iata) => {
    const token = await getToken();
    const url = `/api/v1/bookings/bookingAnalytics/${iata}/seasonalVariance`;

    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(url, {
                headers: { "Firebase-UID": token },
            });
            resolve(response.data);

        } catch (e) {
            console.log(e);
            reject(new Error("error getting getSeasonalVariances"));
        }
    });
};

// add new seasonal-variance for iata object // should be with  dates!
export const addSeasonalVariance = async (params) => {


    const url = `/api/v1/bookings/bookingAnalytics/${params.iata}/seasonalVariance`;

    return new Promise(async (resolve, reject) => {
        try {
            const token = await getToken();

            const response = await fetch(url, {
                method: "POST",
                body: JSON.stringify(params),
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                    "Firebase-UID": token,
                },
            });
            let json = await response.json();
            if (response.status >= 400 && response.status < 600) {
                throw new Error("Bad seasonal-V details");
            }
            resolve(json);
        } catch (e) {
            reject(new Error("Error adding seasonal-V"));
        }
    });
};
//Edit season-V includes add new season-V details for existing iata,
export const editSeasonalVariance = async (data) => {
    const url = `/api/v1/bookings/bookingAnalytics/${data.iata}/seasonalVariance`;

    return new Promise(async (resolve, reject) => {
        try {
            const token = await getToken();

            const response = await fetch(url, {
                method: "PATCH",
                body: JSON.stringify(data.body),
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                    "Firebase-UID": token,
                },
            });
            let json = await response.json();
            if (response.status >= 400 && response.status < 600) {
                throw new Error("Bad seasonal-V details");
            }
            resolve(json);
        } catch (e) {
            reject(new Error("Error editing seasonal-V"));
        }
    });
};

//Edit season-V includes add new season-V details for existing iata,
export const deleteSeasonalAdjustment = async (data) => {

    const url = `/api/v1/bookings/bookingAnalytics/${data.iata}/seasonalVariance/${data.tag}`;
    return new Promise(async (resolve, reject) => {
        try {
            const token = await getToken();

            const response = await fetch(url, {
                method: "DELETE",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                    "Firebase-UID": token,
                },
            });
            let json = await response.json();
            if (response.status >= 400 && response.status < 600) {
                throw new Error("Bad seasonal-V details");
            }
            resolve(json);
        } catch (e) {
            reject(new Error("Error deleteing seasonal-V"));
        }
    });
};


// check if date range and tag name are valid and not selected before!
export const checkDuplication = async (data) => {

    const url = `/api/v1/bookings/bookingAnalytics/${data.iata}/seasonalVariance/checkDuplicate?startDate=${data.startDate}&endDate=${data.endDate}&tag=${data.tag}`;
    return new Promise(async (resolve, reject) => {
        try {
            const token = await getToken();

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                    "Firebase-UID": token,
                },
            });
            let json = await response.json();
            if (response.status >= 400 && response.status < 600) {
                throw new Error("Bad seasonal-V details");
            }
            resolve(json);
        } catch (e) {
            reject(new Error("Error deleteing seasonal-V"));
        }
    });
};

//#endregion

